import type {
  Component,
  NewsletterComponent,
} from '../../../../core/data-sources/content-components/types.js';
import type { ByfunnFrapiArticle } from '../../../types/frapi-types.js';

import { isMovieReview } from '../../components/articles/helpers.js';
import { abTestValue } from '../../../../../public-src/core/js/ab-test.js';

/**
 * Insert the newsletter widget after the component with the nth paragraph.
 *
 * NOTE: text components may contain any number of paragraphs. As a deliberate
 * choice, this function will insert the newsletter widget *after the first text
 * component that brings the paragraph count above `afterNthParagraph`*.
 */
export function insertNewsletterWidget(
  article: ByfunnFrapiArticle,
  components: Component[],
  afterNthParagraph: number = 2,
  isLoggedIn: boolean = false,
) {
  const newsletterComp: NewsletterComponent = {
    type: 'newsletter',
    forMovieReview: isMovieReview(article),
  };

  if (isLoggedIn && (abTestValue() ?? NaN) > 50) {
    let nParagraphs = 0;

    for (let i = 0; i < components.length; i++) {
      const comp = components[i];

      if (comp.type === 'text' && comp.paragraphs) {
        nParagraphs += comp.paragraphs.length;

        if (nParagraphs >= afterNthParagraph) {
          components.splice(i + 1, 0, newsletterComp);

          return;
        }
      }
    }
  }

  // fallback: insert the newsletter component first
  components.splice(0, 0, newsletterComp);
}
